module.exports = __webpack_public_path__ + "static/media/Pixm_logo.6bd5cb3f.PNG";